import React from 'react';
import { EdgeLabelRenderer } from 'reactflow';
import { useTheme } from 'styled-components';

type Props = {
  midX: number;
  midY: number;
  interactive?: boolean;
};

const EdgeLabelWrapper: React.FCC<Props> = ({
  midX,
  midY,
  interactive = false,
  children,
}) => {
  const theme = useTheme();

  return (
    <EdgeLabelRenderer>
      <div
        style={{
          position: 'absolute',
          transform: `translate(-50%, -50%) translate(${midX}px,${midY}px)`,
          fontSize: theme.fontSize('s'),
          pointerEvents: interactive ? 'all' : undefined,
          display: 'flex',
          flexDirection: 'column',
          gap: theme.space('xs'),
        }}
        className="nodrag nopan"
      >
        {children}
      </div>
    </EdgeLabelRenderer>
  );
};

export default EdgeLabelWrapper;
